import MuiButton from "./MuiButton";
import MuiContainer from "./MuiContainer";
import MuiAppBar from "./MuiAppBar";
import MuiPaper from "./MuiPaper";
import MuiSvgIcon from "./MuiSvgIcon";

export default {
  MuiButton,
  MuiContainer,
  MuiAppBar,
  MuiPaper,
  MuiSvgIcon,
};
